export default "__VITE_ASSET__05f0634a__"